<!--
 * @Author: 张天昊
 * @Date: 2024-09-06 11:18:35
 * @LastEditTime: 2024-09-06 11:20:08
 * @LastEditors: 张天昊
 * @Description: 上传触发器
 * @FilePath: /Mobile/src/components/FilePreviewer/UploadTrigger.vue
-->
<script>
import { defineComponent } from 'vue';
export default defineComponent({
  props: {
    iconSize: {
      type: Number,
      default: 18
    },
    color: {
      type: String,
      default: '#999'
    }
  }
})
</script>

<template>
  <div
    class="van-haptics-feedback relative h-full w-full flex items-center justify-center border-1 rounded-4 border-dashed"
    :style="{ borderColor: color, color }"
    @click="$emit('click')"
  >
    <van-icon name="plus" :size="iconSize" />
  </div>
</template>
